import React, {ReactElement} from "react";
import {Grid} from "@components/grid/index";
import {SeriesResponse} from "@mwServices/Series";
import GridPagination from "@components/grid/GridPagination";

interface SeriesGridProps {
    isLoading: boolean;
    className?: string;
    data?: SeriesResponse;
    paginationType?: number;
    onPaginationChange?: (page: number) => void;
    onPaginationSizeChange?: (current: number, perPage: number) => void;
    SeriesRender: (props: SeriesRenderProps) => ReactElement;
    noDataMessage?: string;
    getItemProps: (item: any) => any;
}

export interface SeriesRenderProps {
    item: any;
    filters?: any;
    onClick?: (item) => void;
    isSelected?: boolean;
    toggleSelected?: (id: number) => void;
    noDataMessage: "Series Info Will Be Added Once Individual Comics Are Added To Your Collection",
    showDesktopView?: boolean;
    showEditMultiple?: boolean;
}


const SeriesGrid = ({
    isLoading,
    className,
    data,
    paginationType,
    onPaginationChange,
    onPaginationSizeChange,
    SeriesRender,
    noDataMessage,
    getItemProps,
}: SeriesGridProps) => {

  return (
      <Grid
          isListGrid={true}
          className={className ? className : ''}
          loading={isLoading}
          dataSource={data ? data.series : []}
          noDataMessage={noDataMessage}
          IssueRender={SeriesRender}
          getItemProps={getItemProps}
          pagination={<GridPagination
              data={data}
              paginationType={paginationType}
              onPaginationChange={onPaginationChange}
              onPaginationSizeChange={onPaginationSizeChange}
          />}
      />
  );
};

export default SeriesGrid;
